import { ll } from "../core/ll";
import { emptyFn } from "../core/util";
import { popUp } from "./popUp";

export function saveChanges(options) {
    options = options || {};

    options.condition = options.condition ? true : false;
    options.onConditionFailDiscard = (typeof options.onConditionFailDiscard === "undefined" ? true : options.onConditionFailDiscard);

    options.save = options.save || emptyFn;
    options.discard = options.discard || emptyFn;
    options.always = options.always || emptyFn;
    options.afterPopUp = options.afterPopUp || emptyFn;
    options.cancel = options.cancel || emptyFn;

    let discarded = false;
    let saved = false;
    if (options.condition) {
        popUp({
            title: ll("Wait"),
            guts: "<div style='margin-left:5px; margin-top:20px; margin-bottom:20px'>" + ll("CancelWithoutSaving") + "</div>",
            id: "SaveChanges",
            width: 450,
            buttons: [
                {
                    name: ll("DiscardChanges"),
                    id: "Discard",
                    clickEvent: function () {
                        discarded = true;
                        options.discard();
                        options.always();
                    },
                    className: "left"
                },
                {
                    name: ll("SaveChanges"),
                    id: "Save",
                    clickEvent: function () {
                        saved = true;
                        options.save();
                        options.always();
                    }
                }
            ],
            close: function () {
                if (!discarded && !saved) {
                    options.cancel();
                }
            }
        });

        options.afterPopUp();
    } else {
        if (options.onConditionFailDiscard) {
            options.discard();
        }
        options.always();
    }
}
